module.exports = __webpack_public_path__ + "img/zwsp.bef28139.png";